import { SectionsService } from '../../services/sections.service';
import { UserService } from '../../services/user.service';

export interface LeadContext {
  flow: string;
  selectedLead: any;
  /** Defaults to `flow`. */
  leadEntry?: string;
}

/**
 * Many screens read the record to show from the shared flow / lead entry / selected lead.
 * Switches that shared context (e.g. to open another record in a dialog) and returns a function
 * that restores the host page's previous context — call it when the dialog closes so the page
 * (and its tabs) don't keep running against the other record's id.
 */
export function switchLeadContext(
  sectionsService: SectionsService,
  userService: UserService,
  context: LeadContext
): () => void {
  const previousFlow = sectionsService.getFlow();
  const previousLeadEntry = userService.getLeadEntry();
  const previousSelectedLead = userService.getSelectedLead();

  sectionsService.setFlow(context.flow);
  userService.setLeadEntry(context.leadEntry ?? context.flow);
  userService.setSelectedLead(context.selectedLead);

  let restored = false;
  return () => {
    if (restored) return;
    restored = true;
    sectionsService.setFlow(previousFlow);
    userService.setLeadEntry(previousLeadEntry as string);
    userService.setSelectedLead(previousSelectedLead as string);
  };
}
